import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'CategoryModel';

export class CategoryModel extends BaseModel {
  icon: Nullable<string>;
  level: number;
  parentIds: string[];
  slug: string;
  title: string;
  type = CategoryModel.Type.PROGRAM;
  weight: number;

  constructor(props: CategoryModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<CategoryModel, CategoryModel.Props>(
        props,
      ),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace CategoryModel {
  export enum Type {
    ARTICLE = 'article',
    POPULATION = 'population',
    PROGRAM = 'program',
  }

  export type Props = BaseModel.ModelToProps<CategoryModel>;
}
